import { ref, inject, onMounted, onUnmounted, watch } from 'vue';
import { Subject } from 'rxjs';
import { secondPanelOpenSubject$ } from '@/components/Dashboard/common/WidgetSettingPanel/secondPanelOpenSubject$';

export function useSecondPanel({ key }) {
    const secondPanelVisibility$ = inject(
        'secondPanelVisibility$',
        new Subject()
    );
    const isSecondPanelOpen = ref(false);

    // second panel 열림/닫힘 시 부모 패널에 브로드캐스트 (e.g. SelectSource calendar 닫기)
    watch(isSecondPanelOpen, (v) => {
        secondPanelOpenSubject$.next(v);
    });

    let subscription;
    onMounted(() => {
        subscription = secondPanelVisibility$.subscribe((activeKey) => {
            isSecondPanelOpen.value = activeKey === key;
        });
    });

    onUnmounted(() => {
        subscription?.unsubscribe();
    });

    function closeSecondPanel() {
        secondPanelVisibility$.next(null);
    }

    function toggleSecondPanel() {
        secondPanelVisibility$.next(isSecondPanelOpen.value ? null : key);
    }

    return {
        isSecondPanelOpen,
        secondPanelVisibility$,
        closeSecondPanel,
        toggleSecondPanel,
    };
}
